var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general" },
    [
      !_vm.isInDingTalk
        ? [
            _c("div", { staticClass: "sp" }, [
              _c(
                "h1",
                { staticClass: "com-title com-ht" },
                [
                  _vm._m(0),
                  _c(
                    "el-tooltip",
                    { attrs: { effect: "dark", placement: "bottom-end" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c(
                            "p",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c("img", {
                                staticStyle: {
                                  "max-width": "18px",
                                  "margin-right": "10px"
                                },
                                attrs: {
                                  src: "/images/advancedVersion/pdf_1.png",
                                  alt: ""
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  "变量模板:创建时可以添加变量，发起时填写变量信息"
                                )
                              ])
                            ]
                          ),
                          _c("p", [
                            _c("img", {
                              staticStyle: {
                                "max-width": "18px",
                                "margin-right": "10px"
                              },
                              attrs: {
                                src: "/images/advancedVersion/file_1.png",
                                alt: ""
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                "仅上传文件:创建时无需添加变量，发起时可在线编辑文件内容"
                              )
                            ])
                          ])
                        ]
                      ),
                      _c("span", { staticClass: "el-icon-question" })
                    ]
                  ),
                  !_vm.isInDingTalk
                    ? _c("span", { staticClass: "to-temp-sty" }, [
                        _vm._v("海量合同模板供您参考  "),
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#ec1c1c" },
                            attrs: {
                              href:
                                _vm.GlobalConfig.domain.junziqanIndex +
                                "/contract_template.html",
                              target: "_blank"
                            }
                          },
                          [_vm._v("立即前往>>")]
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "search" },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入模板名称",
                      size: "mini",
                      clearable: ""
                    },
                    model: {
                      value: _vm.templateName,
                      callback: function($$v) {
                        _vm.templateName = $$v
                      },
                      expression: "templateName"
                    }
                  }),
                  _c("el-button", {
                    staticClass: "searchIcon",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      icon: "el-icon-search"
                    },
                    on: {
                      click: function($event) {
                        return _vm.serchTemplate(_vm.templateName)
                      }
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          ;(_vm.templateName = ""), _vm.serchTemplate("")
                        }
                      }
                    },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "box-wrap" },
              [
                _vm._l(_vm.dataList, function(item, index) {
                  return _c("div", { key: index, staticClass: "temone" }, [
                    _c("div", { staticClass: "t-box" }, [
                      _vm.beWord(item.tplName)
                        ? _c("img", {
                            staticClass: "y-img",
                            attrs: { src: "/images/advancedVersion/file_1.png" }
                          })
                        : _c("img", {
                            staticClass: "y-img",
                            attrs: { src: "/images/advancedVersion/pdf_1.png" }
                          }),
                      _c("p", [_vm._v(_vm._s(item.tplName))]),
                      _c("div", { staticClass: "msk" }, [
                        _c(
                          "div",
                          {
                            staticClass: "list_one",
                            staticStyle: { "border-right": "1px solid #ffffff" }
                          },
                          [
                            _c("span", {
                              staticClass: "el-icon-edit-outline",
                              staticStyle: { "margin-top": "1px" },
                              attrs: { title: "修改" },
                              on: {
                                click: function($event) {
                                  return _vm.modulesEditFn(item)
                                }
                              }
                            })
                          ]
                        ),
                        _c("div", { staticClass: "list_one" }, [
                          _c("span", {
                            staticClass: "el-icon-delete",
                            attrs: { title: "删除" },
                            on: {
                              click: function($event) {
                                return _vm.delTpl(item)
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "a-btn",
                        on: {
                          click: function($event) {
                            return _vm.templateUseFn(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.isInDingTalk ? "去发起" : "立即使用"))]
                    )
                  ])
                }),
                _c("div", { staticClass: "temone add" }, [
                  _c("div", { staticStyle: { padding: "20px" } }, [
                    _c("p", [_vm._v("选择创建方式")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "5px"
                        }
                      },
                      [
                        !_vm.isInDingTalk
                          ? _c(
                              "div",
                              {
                                staticClass: "add_button_style",
                                staticStyle: {
                                  margin: "0 auto",
                                  "margin-bottom": "5px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.templateAddChoose(1)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                变量模板\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action: "#",
                              accept: ".doc,.docx",
                              multiple: "",
                              limit: 1,
                              "before-upload": _vm.fileOnBeforeUpload,
                              "on-exceed": _vm.fileHandleExceed,
                              "show-file-list": false,
                              "file-list": _vm.fileList,
                              "on-error": _vm.fileOnError
                            }
                          },
                          [
                            _c("div", { staticClass: "add_button_style" }, [
                              _vm._v("仅上传文件")
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "add_button_style",
                            staticStyle: {
                              margin: "0 auto",
                              "margin-bottom": "10px"
                            },
                            on: { click: _vm.addAdvanceTpl }
                          },
                          [_vm._v("\n                HTML模板\n              ")]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              2
            )
          ]
        : _vm._e(),
      _vm.isShowApiList
        ? [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "box-wrap" },
              [
                _vm._l(_vm.apiTemplateList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "temone temone-center" },
                    [
                      _c("div", { staticClass: "t-box" }, [
                        _vm.beWord(item.tplName)
                          ? _c("img", {
                              staticClass: "y-img",
                              attrs: {
                                src: "/images/advancedVersion/file_1.png",
                                alt: ""
                              }
                            })
                          : _c("img", {
                              staticClass: "y-img",
                              attrs: {
                                src: "/images/advancedVersion/pdf_1.png",
                                alt: ""
                              }
                            }),
                        _c("p", [_vm._v(_vm._s(item.tplName))]),
                        _c("div", { staticClass: "msk" }, [
                          _c(
                            "div",
                            {
                              staticClass: "list_one",
                              staticStyle: {
                                "border-right": "1px solid #ffffff"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "el-icon-edit-outline",
                                staticStyle: { "margin-top": "1px" },
                                attrs: { title: "修改" },
                                on: {
                                  click: function($event) {
                                    _vm.$store.getters.authUser.identityAuth >
                                    -1
                                      ? _vm.$router.push({
                                          path: "/tpl/add/api",
                                          query: { tplId: item.tplId }
                                        })
                                      : (_vm.authDialog = true)
                                  }
                                }
                              })
                            ]
                          ),
                          _c("div", { staticClass: "list_one" }, [
                            _c("span", {
                              staticClass: "el-icon-delete",
                              attrs: { title: "删除" },
                              on: {
                                click: function($event) {
                                  return _vm.delApiTpl(item)
                                }
                              }
                            })
                          ])
                        ])
                      ]),
                      _c("p", { staticClass: "tpid" }, [
                        _vm._v(
                          "\n            ID:" + _vm._s(item.serialNum) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            模板编码:" +
                            _vm._s(item.tplCode) +
                            "\n          "
                        )
                      ])
                    ]
                  )
                }),
                _c(
                  "div",
                  {
                    staticClass: "temone add",
                    on: {
                      click: function($event) {
                        _vm.$store.getters.authUser.identityAuth > -1
                          ? _vm.$router.push({ path: "/tpl/add/api" })
                          : (_vm.authDialog = true)
                      }
                    }
                  },
                  [_c("span", { staticClass: "el-icon-plus" })]
                )
              ],
              2
            )
          ]
        : _vm._e(),
      _vm._l(_vm.authorizationList, function(item, index) {
        return _c("div", { key: index }, [
          _c("div", { staticClass: "sp" }, [
            _c("h1", { staticClass: "com-title com-ht" }, [
              _c("i"),
              _vm._v("授权给我的模板-"),
              _vm.userNameFn(item.corpUserId).userStemFrom === -16 &&
              !_vm.isInDingTalk
                ? _c("img", {
                    attrs: {
                      src: "/images/icon/dingIcon.png",
                      alt: "钉钉",
                      width: "20px"
                    }
                  })
                : _vm._e(),
              _vm._v(_vm._s(_vm.userNameFn(item.corpUserId).corpName))
            ])
          ]),
          _c(
            "div",
            { staticClass: "box-wrap" },
            [
              _vm._l(item.list, function(childItem, childIndex) {
                return _c(
                  "div",
                  { key: childIndex, staticClass: "temone" },
                  [
                    _c("div", { staticClass: "t-box" }, [
                      _vm.beWord(childItem.tplName)
                        ? _c("img", {
                            staticClass: "y-img",
                            attrs: {
                              src: "/images/advancedVersion/file_1.png",
                              alt: ""
                            }
                          })
                        : _c("img", {
                            staticClass: "y-img",
                            attrs: {
                              src: "/images/advancedVersion/pdf_1.png",
                              alt: ""
                            }
                          }),
                      _c("p", [_vm._v(_vm._s(childItem.tplName))])
                    ]),
                    _vm.isAdVn(childItem)
                      ? [
                          _c("div", { staticClass: "b-box" }, [
                            _c(
                              "a",
                              {
                                staticClass: "a-btn",
                                style: childItem.signerFixed
                                  ? "width:100%"
                                  : " width:50%",
                                on: {
                                  click: function($event) {
                                    return _vm.launchFn(
                                      childItem,
                                      item.corpUserId
                                    )
                                  }
                                }
                              },
                              [_vm._v("立即发起\n              ")]
                            ),
                            !childItem.signerFixed
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "a-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.batchLaunchFn(
                                          childItem,
                                          item.corpUserId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("批量发起")]
                                )
                              : _vm._e()
                          ])
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "a-btn",
                              on: {
                                click: function($event) {
                                  return _vm.toApplyFn(
                                    childItem,
                                    item.corpUserId
                                  )
                                }
                              }
                            },
                            [_vm._v("立即使用")]
                          )
                        ]
                  ],
                  2
                )
              }),
              !(item.list && item.list.length)
                ? _c("no-data", {
                    attrs: {
                      slot: "empty",
                      text: "企业暂未授权模板给您，如需使用请联系管理员"
                    },
                    slot: "empty"
                  })
                : _vm._e()
            ],
            2
          )
        ])
      }),
      _c("goto-auth", {
        attrs: { authDialog: _vm.authDialog },
        on: {
          "update:authDialog": function($event) {
            _vm.authDialog = $event
          },
          "update:auth-dialog": function($event) {
            _vm.authDialog = $event
          }
        }
      }),
      _vm.plDialogVisible
        ? _c("batch-launch", {
            attrs: {
              show: _vm.plDialogVisible,
              tplId: _vm.batchTplId,
              nowToken: _vm.nowToken
            },
            on: {
              "update:show": function($event) {
                _vm.plDialogVisible = $event
              }
            }
          })
        : _vm._e(),
      _c("editor-pup", {
        attrs: { showofficeEditor: _vm.showofficeEditor, editor: _vm.editor },
        on: {
          "update:showofficeEditor": function($event) {
            _vm.showofficeEditor = $event
          },
          "update:showoffice-editor": function($event) {
            _vm.showofficeEditor = $event
          },
          saveLoading: _vm.saveLoading
        }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i"), _vm._v("我的模板  ")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("API模板")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0908cae0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0908cae0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/general.vue
// module id = kPT1
// module chunks = 65